import React from 'react';
import RadioGroupField from 'components/RadioGroupField';
import useOptions from '../../hooks/useOptions';

import './LeaseField.styles.scss';
import './LeaseField.styles.responsive.scss';

const LeaseField: React.FC = () => {
  const { isThereLeaseOptions } = useOptions();

  return (
    <div className="lease-field">
      <RadioGroupField
        name="isThereLease"
        options={isThereLeaseOptions}
        styled
      />
    </div>
  );
};

export default LeaseField;
